import { IconRounded } from '@doltech/icons/IconRounded';
import { Space } from 'antd';
import * as React from 'react';
import { useSlate } from 'slate-react';
import styled from 'styled-components';

import { setDefaults } from '../../../../../slatePlugins/common/utils/setDefaults';
import { InputTextMaterial } from '../../../../Form/Input/InputMaterial/InputTextMaterial';
import { shadows } from '../../../../shadows';
import { useItemContextToolbar } from '../../../toolbars/balloon-toolbar-at-edge-block/withItemContextToolbar';
import { DolBalloonToolbar } from '../../../toolbars/BalloonToolbar';
import { Divider } from '../../../toolbars/Divider';
import ColorSelector from '../../highlight/toolbar/ColorSelector';
import { DEFAULT_ROUNDED, ELEMENT_ROUNDED } from '../defaults';
import { setAnnotationText } from '../transform/setAnnotationText';
import { removeRoundBackgroundColor, setRoundBackgroundColor } from '../transform/setRoundColor';

export const useCurrentColorKey = (colors) => {
  const { selectedItem } = useItemContextToolbar() as any;
  let currentColor = null;
  if (selectedItem) {
    currentColor = selectedItem[0]?.colorKey || colors?.[0].key;
  }

  return currentColor;
};

export const ColorMenu = ({ colors, options }) => {
  const editor = useSlate();
  const currentColor = useCurrentColorKey(colors);
  const { selectedItem } = useItemContextToolbar();
  return (
    <ColorSelector
      colors={colors}
      currentColor={currentColor}
      onDeselectColor={() => {
        if (selectedItem) {
          removeRoundBackgroundColor(editor, options, { at: selectedItem[1] });
        }
      }}
      onSelectColor={(color) => {
        if (selectedItem) {
          setRoundBackgroundColor(editor, options, color, { at: selectedItem[1] });
        }
      }}
    />
  );
};

export const useCurrentAnnotationText = () => {
  const { selectedItem } = useItemContextToolbar() as any;
  let currentColor = null;
  if (selectedItem) {
    currentColor = selectedItem[0].annotationText;
  }

  return currentColor;
};

const AnnotationInputBase = ({ options, placeholder = 'Nhập tag' }) => {
  const editor = useSlate();
  const currentText = useCurrentAnnotationText();
  const [textValue, setTextValue] = React.useState(currentText);
  const { selectedItem } = useItemContextToolbar();

  React.useEffect(() => {
    setTextValue(currentText);
  }, [currentText]);

  const setAnnotationValue = React.useCallback(
    (event) => {
      if (selectedItem) {
        setAnnotationText(editor, options, event.target.value, { at: selectedItem[1] });
      }
    },
    [editor, options, selectedItem]
  );

  return (
    <InputTextMaterial
      value={textValue}
      placeholder={placeholder}
      onBlur={setAnnotationValue}
      onChange={(event) => setTextValue(event.target.value)}
    />
  );
};

export const AnnotationInput = React.memo(AnnotationInputBase);

const ToolbarWrapper = styled.div`
  background: #fff;
  border: 1px solid #e9eaeb;
  box-shadow: ${shadows.zIndex3};
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 4px;
  .ant-space-align-center {
    .ant-space-item {
      display: flex;
      align-items: center;
    }
  }
`;

const InputWrapper = styled.div`
  width: 100px;
`;

const ToolbarRoundedContextActionBase = () => {
  const options = setDefaults({}, DEFAULT_ROUNDED);
  const {
    roundedElement: { colors },
  } = options;
  return (
    <DolBalloonToolbar.AtEdgeBlock theme="light" type={ELEMENT_ROUNDED}>
      <ToolbarWrapper>
        <Space>
          <IconRounded width="24px" height="24px" />
          <Divider />
          <ColorMenu colors={colors} options={options} />
          <InputWrapper>
            <AnnotationInput options={options} />
          </InputWrapper>
        </Space>
      </ToolbarWrapper>
    </DolBalloonToolbar.AtEdgeBlock>
  );
};

export const ToolbarRoundedContextAction = React.memo(ToolbarRoundedContextActionBase);
